export enum CaptchaType {
  GOOGLE = 'google',
  YANDEX = 'yandex',
}

export enum YandexCaptchaStatus {
  SUCCESS = 'success',
  ERROR = 'error',
  NOT_VALIDATED = 'not-validated',
}
